var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_tab"},[_c('div',{attrs:{"id":"board_tab"}},_vm._l((_vm.categories),function(key,index){return _c('div',{key:index,class:`board01`},[_c('strong',[_vm._v(_vm._s(key.title))]),_c('ul',_vm._l((_vm.listOfCategory[key.lnbid]),function(value,i){return _c('li',{key:i,class:{ new: _vm.boo(value) }},[_c('a',[(value.category)?_c('strong',[_vm._v("["+_vm._s(value.category)+"]")]):_vm._e(),_vm._v(_vm._s(value.subject))])])}),0),_c('span',{staticClass:"m_more"},[_c('router-link',{attrs:{"to":{
            name: `${_vm.params.category}`,
            query: {
              data: JSON.stringify({
                lnbid: _vm.params.lnbid,
                type: _vm.params.type,
                top: _vm.params.lnbid,
                title: _vm.params.title,
              }),
            },
          }}})],1)])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }